import request from '@/utils/seftRequest';
// import { stringify } from 'qs';

// 查询账单，params: {token: ''} 原接口/whalecloud/cvbs/v1/qryDue4CB
export function qryDue4CB(data) {
  return request('/ding/custService/cvbs/v1/qryDue4CB', {
    method: 'POST',
    body: data,
  });
}

// 查询账单，二维码进行缴费查询账单 原接口/whalecloud/cvbs/v1/qryDue
export function qryDue(data) {
  return request('/ding/custService/cvbs/v1/qryDue', {
    method: 'POST',
    body: data,
  });
}

export function qryConfigParams(params) {
  return request('/ding/common/drmConfigItemParams', {
    params,
  });
}
